<div class="container">
    <div class="inputs" [ngStyle]="{
      gap: uploadedOnce ? '35%' : '10%',
      'margin-top.px': uploadedOnce ? '0' : '45',
      'margin-left.px': uploadedOnce ? '40' : '0'
    }">
        <app-audio-record (showOutput)="showRecoredOutput($event)" (showLoader)="showLoader($event)" [uploadedOnce]="uploadedOnce"></app-audio-record>
        <app-audio-upload (showOutput)="showUploadedOutput($event)" (showLoader)="showLoader($event)" [uploadedOnce]="uploadedOnce"></app-audio-upload>
    </div>

    <div *ngIf="isLoading" style="position: fixed; top: 40%; left: 45%; z-index: 1">
        <img src="./../../../assets/Bean Eater-1s-200px.svg" />
    </div>
</div>